import React, { FunctionComponent } from 'react';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconCalendarDay: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faCalendarDay} />;

export { BrassIconCalendarDay };
